export default __webpack_public_path__ + "static/media/openness3Img2.af47c580.png";